import { EventEmitter } from '@angular/core';
import { ApiOrderline } from '../../../cart/models/cart-models';
import { ABSOLUTE_QUANT, RELATIVE_QUANT, ThemeConfig } from '../../../core/helpers/theme-config';
var quantityType = ThemeConfig.get('catalog', 'quantity-type');
var hasDetails = ThemeConfig.get('catalog', 'has-details');
var CartTableLineComponent = /** @class */ (function () {
    function CartTableLineComponent() {
        this.onLineChange = new EventEmitter();
        this.onLineDelete = new EventEmitter();
        this.onDetails = new EventEmitter();
    }
    Object.defineProperty(CartTableLineComponent.prototype, "product", {
        get: function () {
            return this.line.product;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "imageUrl", {
        get: function () {
            return (this.product.assets.imgs
                .find(function (img) { return img.type === 'detail'; }) || {})
                .src;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "name", {
        get: function () {
            return this.product.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "productNumber", {
        get: function () {
            return this.product.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "productDisplayCode", {
        get: function () {
            return this.product.displayCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "hasDetails", {
        get: function () {
            return hasDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "stepping", {
        get: function () {
            return quantityType === ABSOLUTE_QUANT
                ? this.line.stepping
                : 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "actualStepping", {
        get: function () {
            return this.line.stepping || 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "minQuantity", {
        get: function () {
            return quantityType === RELATIVE_QUANT
                ? this.line.minQuantity / this.line.stepping
                : this.line.minQuantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "absoluteQuantity", {
        get: function () {
            return this.line.quantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "relativeQuantity", {
        get: function () {
            return this.line.quantity / this.line.stepping;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "unitPrice", {
        get: function () {
            return this.line.itemprice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "normalUnitPrice", {
        get: function () {
            return this.line.origitemprice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "hasDiscount", {
        get: function () {
            return this.discount > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "discount", {
        get: function () {
            return this.line.discount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "linePrice", {
        get: function () {
            return this.line.lineprice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "normalLinePrice", {
        get: function () {
            return this.line.origlineprice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "stockMessage", {
        get: function () {
            return 'stock.code-' + this.line.delivery.expected.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "stockMessageClass", {
        get: function () {
            return 'stockmessage-code-' + this.line.delivery.expected.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "stockIconClass", {
        get: function () {
            return this.stockIconClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "week", {
        get: function () {
            return this.line.delivery.expected.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "calculatedQuantity", {
        get: function () {
            return quantityType === RELATIVE_QUANT
                ? this.relativeQuantity
                : this.absoluteQuantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "displayQuantity", {
        get: function () {
            return this.quantityPickerRelative
                ? this.relativeQuantity
                : this.absoluteQuantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "showQuantityPickerAnimated", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'animated');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "quantityPickerRelative", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'relative');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "hasFacetsToDisplay", {
        get: function () {
            return this.showFacets && this.showFacets.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableLineComponent.prototype, "facetsWithValues", {
        get: function () {
            var _this = this;
            if (this.product.facetsWithValues && this.product.facetsWithValues.length > 0) {
                var applicableFacetWithValues = this.product.facetsWithValues
                    .filter(function (facetWithValues) { return _this.showFacets.indexOf(facetWithValues.facetgroupcode) > -1; });
                return applicableFacetWithValues;
            }
        },
        enumerable: true,
        configurable: true
    });
    CartTableLineComponent.prototype.openDetails = function (product) {
        this.onDetails.emit(product);
    };
    CartTableLineComponent.prototype.onQuantityChanged = function (event) {
        this.onLineChange.emit({
            quantity: event.quantity,
            product: this.line.product._id,
            includeExtraCosts: true
        });
    };
    CartTableLineComponent.prototype.setPlaceholder = function (event) {
        event.target.src = 'https://via.placeholder.com/125x125/f7f7f7?text=No+image';
    };
    CartTableLineComponent.prototype.removeLine = function () {
        this.onLineDelete.emit(this.line._id);
    };
    return CartTableLineComponent;
}());
export { CartTableLineComponent };
